import { Link } from 'react-router-dom';
import { apiClient } from '../../tjenester/apiClient';

function PropertyCard({ portfolioReturnUrl, property }) {
  return (
    <Link
      className="block overflow-hidden rounded-[28px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] no-underline shadow-[0_22px_60px_rgba(24,50,40,0.08)] transition duration-200 hover:-translate-y-1 hover:shadow-[0_28px_70px_rgba(24,50,40,0.14)]"
      to={`/eiendom/${property.slug}?returnTo=${encodeURIComponent(portfolioReturnUrl)}`}
    >
      <div
        className="relative flex min-h-[220px] items-center justify-center bg-[linear-gradient(145deg,rgba(202,188,157,0.65),rgba(111,141,123,0.45)),repeating-linear-gradient(-45deg,rgba(255,255,255,0.2),rgba(255,255,255,0.2)_12px,transparent_12px,transparent_24px)] font-semibold text-[#163127]"
      >
        {property.imageUrl ? (
          <img
            alt={property.name}
            className="absolute inset-0 h-full w-full object-cover"
            src={apiClient.resolveMediaUrl(property.imageUrl)}
          />
        ) : null}
        <span className="absolute left-4 top-4 z-10 rounded-full bg-[rgba(249,245,238,0.92)] px-3 py-1 text-xs uppercase tracking-[0.12em] text-[#163127]">
          {property.status}
        </span>
        {property.imageUrl ? null : <span>Bilde kommer</span>}
      </div>
      <div className="px-[20px] py-6 sm:px-6">
        <p className="mb-2.5 text-[#7c6b52]">{property.address}</p>
        <h3 className="mb-3.5 text-[1.45rem] text-[#163127]">{property.name}</h3>
        <dl className="mb-[18px] grid gap-3.5 sm:grid-cols-2 xl:grid-cols-3">
          <div className="min-w-0 rounded-[18px] bg-[rgba(255,255,255,0.7)] p-3.5 md:min-h-[100px]">
            <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Type</dt>
            <dd className="m-0 break-words font-semibold text-[#163127]">{property.type}</dd>
          </div>
          <div className="min-w-0 rounded-[18px] bg-[rgba(255,255,255,0.7)] p-3.5 md:min-h-[100px]">
            <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Storrelse</dt>
            <dd className="m-0 break-words font-semibold text-[#163127]">{property.size}</dd>
          </div>
          {property.rentPerMonth ? (
            <div className="min-w-0 rounded-[18px] bg-[rgba(255,255,255,0.7)] p-3.5 md:min-h-[100px]">
              <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Manedsleie</dt>
              <dd className="m-0 break-words font-semibold text-[#163127]">{property.rentPerMonth}</dd>
            </div>
          ) : null}
          {property.rooms ? (
            <div className="min-w-0 rounded-[18px] bg-[rgba(255,255,255,0.7)] p-3.5 md:min-h-[100px]">
              <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Rom</dt>
              <dd className="m-0 break-words font-semibold text-[#163127]">{property.rooms}</dd>
            </div>
          ) : null}
          <div className="min-w-0 rounded-[18px] bg-[rgba(255,255,255,0.7)] p-3.5 md:min-h-[100px]">
            <dt className="mb-2 text-[0.78rem] uppercase tracking-[0.1em] text-[#7c6b52]">Ledig fra</dt>
            <dd className="m-0 break-words font-semibold text-[#163127]">{property.availableFrom}</dd>
          </div>
        </dl>
        <p className="text-[1.05rem] leading-[1.7] text-[#355046]">{property.summary}</p>
        <span className="mt-4 inline-flex font-semibold text-[#1d4c3b]">Se detaljside</span>
      </div>
    </Link>
  );
}

export default PropertyCard;